{#if show}
  <select
    id={id || ''}
    tabindex={!readonly ? "1" : "-1"}
    disabled={readonly}
    class="selector { css && css.classes() }"
    style={ css && css.styled() }
    on:change
    on:blur
    bind:value={value}>
    
    {#each (options || []) as opt}
      <option value={opt.value.toString()}>{opt.text}</option>
    {/each}

    {#if !options}<slot></slot>{/if}
  </select>
{/if}

<style>
.selector {
  display: inline-block;
  box-sizing: border-box;
  background-color: transparent;
  margin: 0;
  padding: 0.45rem 0.5rem;
  font-size: 100%;
  font-weight: normal;
  font-style: normal;
  line-height: 1em;
}
</style>

<svelte:window bind:innerWidth={vw} />

<script>
  import { createEventDispatcher } from 'svelte'
  import { Css } from '../theme';

  export let
    value,
    options = null, 
    readonly = null,
    id = null; // the ControlId 

  let 
    vw = 0,
    show = true,
    css = null,
    dispatch = createEventDispatcher();

  $: if (value) {
    // MUST cast to a string otherwise does not set correctly the initial option
    value = value.toString(); 

    // "change" event does not work well here, so we must use the 
    // "value"  change to signal that some options was selected
    dispatch("selected", { value: value }); 
  }

  $: if (vw && $$props) {
    css = Css($$props)
          .shorthand(['xs','sm','nm','md','lg','xl','h2', 'h1'], 'font-size')
    show = css.visible(show, vw);
  }
</script>
